var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5866 13.0714C26.1783 12.4797 26.1783 11.5203 25.5866 10.9286L15.9443 1.28626C15.3526 0.694557 14.3932 0.694557 13.8015 1.28626C13.2098 1.87796 13.2098 2.83731 13.8015 3.42901L22.3725 12L13.8015 20.571C13.2098 21.1627 13.2098 22.122 13.8015 22.7137C14.3932 23.3054 15.3526 23.3054 15.9443 22.7137L25.5866 13.0714ZM0.878906 13.5152H24.5153V10.4848H0.878906V13.5152Z",
    fill: "#1C2B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.b4ead7f2c84373668ad83a79ff0cb1e6.svg";
export { ForwardRef as ReactComponent };